import styled from 'styled-components'

import { helpers } from 'styles'

export const PolicyText = styled.span`
	color: ${helpers.color.textLight};
`
